import React, { useState } from "react";
import { Box, Typography, Container } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useLanguage } from "../../context/LanguageContext";
import { NAV_MENUS } from "../../components/layout/ActionHeader";
import AppBreadcrumbs from "../../components/shared/Breadcrumbs/AppBreadcrumbs";

const Sitemap = () => {
    const navigate = useNavigate();
    const { language } = useLanguage();
    const [openMenu, setOpenMenu] = useState(null);

    const handleNavigation = (item) => {
        if (item.external && item.href) {
            window.open(item.href, "_blank", "noopener,noreferrer");
        } else if (item.path) {
            navigate(item.path);
        }
    };

    return (
        <Box sx={{ bgcolor: "#fff", minHeight: "100vh" }}>

            <Box sx={{ px: { xs: 2, md: 4 }, py: 2, mb: 2 }}>
                {/* Breadcrumb */}
                <AppBreadcrumbs />
            </Box>
            <Container maxWidth="md" sx={{ py: 0 }}>
                {/* Breadcrumb */}

                {/* Title */}
                <Typography variant="h5" sx={{ fontWeight: 600, mt: 1, mb: 3 }}>
                    {language === "mr" ? "साइटमॅप" : "Sitemap"}
                </Typography>

                {/* Home Link */}
                <Typography
                    sx={{
                        fontSize: "0.9rem",
                        fontWeight: 500,
                        mb: 2,
                        cursor: "pointer",
                        "&:hover": { textDecoration: "underline" },
                    }}
                    onClick={() => navigate("/")}
                >
                    {language === "mr" ? "मुख्यपृष्ठ" : "Home"}
                </Typography>

                {/* Sitemap Menus */}
                {NAV_MENUS.map((menu) => (
                    <Box key={menu.id} sx={{ mb: 2 }}>
                        {/* Parent Menu */}
                        <Box
                            onClick={() =>
                                setOpenMenu(openMenu === menu.id ? null : menu.id)
                            }
                            sx={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                cursor: "pointer",
                                py: 1,
                                borderBottom: "1px solid #e0e0e0",
                            }}
                        >
                            <Typography sx={{ fontSize: "0.9rem", fontWeight: 500 }}>
                                {menu.label(language)}
                            </Typography>

                            <Typography sx={{ fontSize: "0.9rem" }}>
                                {openMenu === menu.id ? "▾" : "▸"}
                            </Typography>
                        </Box>

                        {/* Child Items */}
                        {openMenu === menu.id && (
                            <Box sx={{ pl: 2 }}>
                                {menu.items.map((item) => (
                                    <Typography
                                        key={item.id}
                                        onClick={() => handleNavigation(item)}
                                        sx={{
                                            py: 1,
                                            fontSize: "0.9rem",
                                            cursor: "pointer",
                                            borderBottom: "1px solid #f0f0f0",
                                            "&:hover": {
                                                color: "#1E3A8A",
                                                bgcolor: "#f9f9f9",
                                            },
                                        }}
                                    >
                                        {item.label(language)}
                                    </Typography>
                                ))}
                            </Box>
                        )}
                    </Box>
                ))}
            </Container>
        </Box>
    );
};

export default Sitemap;